import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';

import { CommerceOrders, CoreLink } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { clearPageInformation, setPageInformation, setPageViewSent } from '../../../store/actions/UI';

import './style.scss';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

const Empty = () => (
  <div>Je winkelwagen is leeg.</div>
);

const Wrapper = ({ children }) => (
  <table className="OrderOverview">
    {children}
  </table>
);

const Header = () => (
  <thead>
    <tr>
      <th>Order nummer:</th>
      <th>Status:</th>
      <th>Aantal producten:</th>
      <th>Totaalprijs:</th>
    </tr>
  </thead>
);

const Item = ({ order }) => (
  <tbody>
    <tr key={order.get('id')}>
      <td><CoreLink to={`/order/${order.get('id')}`}>#{order.getIn(['attributes', 'order_number'])}</CoreLink></td>
      <td>{order.getIn(['attributes', 'state'])}</td>
      <td>{order.getIn(['relationships', 'order_items', 'data'], Immutable.List()).count()}</td>
      <td>{order.getIn(['attributes', 'balance', 'formatted'])}</td>
    </tr>
  </tbody>
);

const OrderOverview = () => {
  const PAGE_TITLE = 'Bestellingen | VeiligheidNL';
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearPageInformation());
    dispatch(setPageInformation(PAGE_TITLE));
    dispatch(setPageViewSent(false));
  }, []);

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container>
        <CommerceOrders
          wrapper={Wrapper}
          header={Header}
          item={Item}
          empty={Empty}
        />
      </Container>
    </>
  );
};

export default OrderOverview;
